import React from 'react';
import UploadRestriction from './UploadRestriction';

const attachmentSizeExceededToast = {
  level: 'warning',
  title: 'Attachment too large',
  hideIcon: true,
  message: <UploadRestriction />,
} as const;

export default attachmentSizeExceededToast;
